import React from 'react'
import DashboardWrapper from '../../layout/DashboardWrapper/DashboardWrapper';
import TableSection from '../../components/TableSection/TableSection';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import { Box, Typography } from '@mui/material';
import styles from "../../styles/pages/searchResult.module.scss"
import { useNavigate } from 'react-router-dom';
import {  useDashboardLoadingState, useMCMemberList } from '../../hooks/useSelector';
import { toUppercase } from '../../services/utils';
import BackdropLoader from '../../ui/BackdropLoader/BackdropLoader';

export default function CustomerDashboardSearch() {
  const memberListing = useMCMemberList();
  const loadingStatus = useDashboardLoadingState();
  const navigate = useNavigate();

 
const redirectToCustomerDetails =(e,customerId)=>{
  navigate(`/dashboard/search-detailed/${customerId}`)
}
  return (
   <DashboardWrapper>
    <TableSection>
   
    <TableHead>
          <TableRow >
            <TableCell align="center"><Typography variant='body1'>Last Name</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>First Name</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>ID</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>Email</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>Phone</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>Country</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>City</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>State</Typography></TableCell>
            <TableCell align="center"><Typography variant='body1'>Address</Typography></TableCell>
          </TableRow>
    </TableHead>
    <TableBody>
     <BackdropLoader open={loadingStatus} />

         {memberListing?.memberList !== undefined ? 
         <>
         {memberListing?.memberList?.length !== 0 ? 
         
         <>
         {memberListing?.memberList?.map((row) => (
            
            <TableRow className={styles.selectedTableRow} 
            onClick={(event) =>redirectToCustomerDetails(event, row?.id_member)}
              key={row._id}
              >
              <TableCell align="center"  scope="row">
                <Typography variant='body1'>{toUppercase(row.lastName)}</Typography>
              </TableCell>
              <TableCell  align="center"><Typography variant='body1'>{toUppercase(row.firstName)}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.id_member}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.email}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.phone || "--"}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.countryFull || "--"}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.city || "--"}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.stateFull || "--"}</Typography></TableCell>
              <TableCell  align="center"><Typography variant='body1'>{row.address1 || "--"}</Typography></TableCell>
            </TableRow>
          ))}
       </> 
          :   <TableCell colSpan={9} className={styles.no_data}> <Box> No member found.</Box></TableCell>}
         </>  :
         <TableCell colSpan={9} className={styles.no_data}> <Box> Search by name, email, or serial number.</Box></TableCell>
         }
      </TableBody>
    </TableSection>
   </DashboardWrapper>
  )
}
